import { useEffect, useState } from 'react';
import { fetchTranscript } from '@models/transcripts/transcriptRepository';

export function useTranscriptController(transcriptUrl) {
  const [transcript, setTranscript] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!transcriptUrl) {
      setTranscript(null);
      setLoading(false);
      setError(null);
      return undefined;
    }

    const controller = new AbortController();
    let cancelled = false;
    setTranscript(null);
    setLoading(true);
    setError(null);

    fetchTranscript(transcriptUrl, { signal: controller.signal })
      .then((nextTranscript) => {
        if (!cancelled) {
          setTranscript(nextTranscript);
        }
      })
      .catch((fetchError) => {
        if (cancelled || fetchError?.name === 'AbortError') {
          return;
        }

        console.error('Error fetching transcript:', fetchError);
        setError('Oops! We couldn\'t load this transcript. Please try again later.');
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [transcriptUrl]);

  return { transcript, loading, error };
}
